import { Backdrop } from './Backdrop';
import { MessageBox } from './MessageBox';

export class CongratsMessageForFun {
  private message;
  private backdrop;
  constructor(scene, gameWidth, gameHeight) {
    this.backdrop = new Backdrop(scene);

    this.message = new MessageBox(
      scene,
      gameWidth * 0.8,
      gameHeight * 0.65,
      [
        {
          xPos: 250,
          yPos:250,
          text: "CONGRATULATIONS!",
          fontSize: '35px',
          fontStyle: 'bold',
          center:"1",
          color: "#OOO"
        }, {
          xPos: 250,
          yPos:325,
          text: "IF YOU HAD BEEN PLAYING FOR PRIZES YOU\nWOULD HAVE WON",
          center:"1",
          fontSize: '25px',
          color: "#OOO"},
        {
          xPos: 250,
          yPos:400,
          text: scene.getPrizeAmount(),
          center:"1",
          fontSize: '50px',
          color: "#OOO"},
        {
          xPos: 250,
          yPos:600,
          text: "PLAY AGAIN?\nWIN UP TO $5000 IN THE PLAY FOR PRIZES\nMODE.",
          center:"1",
          fontSize: '25px',
          color: "#OOO"}
      ],
      [
        { name: 'play-prizes', method: this.quit, width: 270, height: 60, x: 300, y: 700 },
        { name: 'play-fun', method: this.replay, width: 270, height: 60, x: 300, y: 775 }

      ],
      [
        { width: 500, height: 160, name: 'branding', x: 0.5, y: 0.15 },



      ],
    null,
    'resultsbackground'
    );
  }

  public quit = () => {
    // @ts-ignore
    if (typeof PblInterface !== 'undefined') {
      // @ts-ignore
      PblInterface.game.exit();
    } else {
      window._po_gm.end();
    }
  };

  public replay = () => {
    this.backdrop.destroy();
    this.message.destroy();
    // @ts-ignore
    if (typeof PblInterface !== 'undefined') {
      // @ts-ignore
      PblInterface.game.replay();
    } else {
      window._po_gm.replay();
    }
    // window.location.reload();
  };
}
